const galleryModules = import.meta.glob<{ default: string }>(
  "../assets/ibiza-cars/**/*.{jpg,jpeg,png,webp,avif}",
  { eager: true }
);

const getGallery = (slug: string) =>
  Object.entries(galleryModules)
    .filter(([path]) => path.includes(`/ibiza-cars/${slug}/`))
    .sort(([a], [b]) => a.localeCompare(b, undefined, { numeric: true }))
    .map(([, module]) => module.default);

export const ibizaCarGalleries = {
  "lamborghini-revuelto": getGallery("lamborghini-revuelto"),
  "ferrari-f8-spyder": getGallery("ferrari-f8-spyder"),
  "ferrari-portofino-m": getGallery("ferrari-portofino-m"),
  "lamborghini-huracan-evo-spyder": getGallery("lamborghini-huracan-evo-spyder"),
  "lamborghini-urus-s": getGallery("lamborghini-urus-s"),
  "porsche-911-gt3-rs": getGallery("porsche-911-gt3-rs"),
  "porsche-911-carrera-4s": getGallery("porsche-911-carrera-4s"),
  "mercedes-g63-amg": getGallery("mercedes-g63-amg"),
  "audi-rsq8": getGallery("audi-rsq8"),
  "range-rover-sport-dynamic": getGallery("range-rover-sport-dynamic"),
  "land-rover-defender-110": getGallery("land-rover-defender-110"),
  "range-rover-sport": getGallery("range-rover-sport"),
} as const;